module.exports = __webpack_public_path__ + "img/855d67781a4c97d01634e335e08d550a.png";